import React, { memo, useCallback } from 'react';
import { useToggle } from 'react-use';
import { BookmarkIcon, StyledBottom, StyledButton, StyledDropBlock, StyledListItemContent, StyledMenu, StyledScrollable, StyledFirstItem } from './styled';
import { useMenu } from '../../../menu';
import { Body1, Body2 } from '../../../typography';
import { ListItemIcon } from '../../../list-item-icon';
import { ListItemContent } from '../../../list-item-content';
import { ListItem } from '../../../list-item';
import AccordionIcon from '../../../icon/special/accordion-styled';
import { Item } from './item';
import { SavedItemsContainer } from './saved-items-container';
import { SaveModal } from './save-modal';
export const SearchManagement = memo(function SearchManagement({ history, onSave, onRemove, onSelect, savedItems, isSaveAvailable }) {
    const { isOpenMenu, handleToggleMenu, handleCloseMenu } = useMenu(false);
    const [isOpenSaveModal, toggleSaveModal] = useToggle(false);
    const openSaveModal = useCallback(() => toggleSaveModal(true), [toggleSaveModal]);
    const closeSaveModal = useCallback(() => toggleSaveModal(false), [toggleSaveModal]);
    const onClickSave = useCallback(() => {
        openSaveModal();
        handleCloseMenu();
    }, [handleCloseMenu, openSaveModal]);
    const [isOpenSavedItems, toggleIsOpenSavedItems] = useToggle(!Boolean(history === null || history === void 0 ? void 0 : history.length));
    const handleClickOutside = useCallback((e) => {
        if (document.body.contains(e.target)) {
            handleCloseMenu();
        }
    }, [handleCloseMenu]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledMenu, { position: "bottom-end", isOpen: isOpenMenu, onClickOutside: handleClickOutside, content: React.createElement(StyledDropBlock, null,
                React.createElement(StyledScrollable, null,
                    Boolean(savedItems.length) && (React.createElement(ListItem, { onClick: toggleIsOpenSavedItems, divider: true, button: true },
                        React.createElement(ListItemIcon, null,
                            React.createElement(AccordionIcon, { "$isOpen": isOpenSavedItems, height: "16" })),
                        React.createElement(ListItemContent, null,
                            React.createElement(Body1, null, "My Saved Searches")))),
                    React.createElement(SavedItemsContainer, { isOpen: isOpenSavedItems, useCollapse: true }, savedItems.map((item) => (React.createElement(Item, { key: item.id, onClick: onSelect, item: item, onRemove: onRemove })))), history === null || history === void 0 ? void 0 :
                    history.map((item) => (React.createElement(Item, { key: item.id, isHistory: true, onClick: onSelect, item: item, onRemove: onRemove }))),
                    Boolean(!savedItems.length && !(history === null || history === void 0 ? void 0 : history.length)) && (React.createElement(ListItem, null,
                        React.createElement(StyledListItemContent, { component: "span" },
                            React.createElement(Body2, null, "No Saved Searches"))))),
                React.createElement(StyledBottom, null,
                    React.createElement(StyledFirstItem, null),
                    React.createElement(ListItem, { button: true, onClick: onClickSave, disabled: !isSaveAvailable },
                        React.createElement(StyledListItemContent, null, "Save a New Search")))) },
            React.createElement(StyledButton, { EndIcon: React.createElement(AccordionIcon, { "$isOpen": isOpenMenu, height: "16" }), variant: "outline", text: "Search Management", StartIcon: React.createElement(BookmarkIcon, null), onClick: handleToggleMenu })),
        React.createElement(SaveModal, { isOpen: isOpenSaveModal, closeModal: closeSaveModal, onSave: onSave })));
});
